// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1O0N3","tabsBox":"styles_tabsBox__Eu0Bc","createButton":"styles_createButton__O3xRk"};